import axios, { AxiosError } from 'axios';
import { put, takeEvery } from 'redux-saga/effects';
import * as repActions from 'Actions/repertoire';
import * as appActions from 'Actions/app';
import { RepertoireActionTypes } from 'Types/RepertoireTypes';
import { awsRum } from 'Utils/AwsRum';
import logger from 'Utils/Logger';
import { CreateRepertoireSession } from 'Types/RepertoireTypes';
import { getCurrentAuthToken } from 'Utils/Auth';

const baseUrl = `${process.env.REACT_APP_BACKEND_URL}/api/v1/`;

async function postSession(jwtToken: string, body: { repertoire: { id: number } }) {
  return axios.post(baseUrl + 'rep-play-session', body, {
    headers: { Authorization: `Bearer ${jwtToken}` },
  });
}

function* createRepSession(action: CreateRepertoireSession): Generator<unknown, void, unknown> {
  logger.debug('create level session entered');
  const jwtToken = yield getCurrentAuthToken();
  const body = {
    repertoire: {
      id: action.payload.repertoire_id,
    },
    error_recognition_mode: action.payload.error_recognition_mode,
  };
  try {
    const playSession = yield postSession(jwtToken, body);
    logger.debug('play session created', playSession?.data?.id);
    yield put(appActions.invalidateDashboardCache());
    yield put(repActions.setPlaySessionId(playSession.data.id));
  } catch (err) {
    console.error(err);
    if (err instanceof AxiosError && err?.response?.status && err.response.status > 499) {
      awsRum?.recordError(err);
    } else if (!(err instanceof AxiosError)) {
      awsRum?.recordError(err);
    }
  }
}

export default [takeEvery(RepertoireActionTypes.CREATE_REPERTOIRE_SESSION, createRepSession)];
